module.exports = __webpack_public_path__ + "media/assets/images/curation/facebook-2b521e971ee8feeea4dcbefbe05bd88c.svg";